import React, { Component } from 'react';
//import {backRouter} from '../helpers';
// Include page theme here
import Home from './themes/Home';
import Contact from './themes/Contact';
import Page from './themes/Page';
import Catalog from './themes/Catalog';
import Gallery from './themes/Gallery';
import NotFound from './themes/NotFound';
class Content extends Component {
    render() { 
        const client = this.props.app.client;
        const {pages,settings} = this.props.app;
        const {params,path} = this.props.match;
        if(path ==="/"){
            return <Home  history={this.props.history} settings={settings} pages={pages}  page="home" client={client}/>
        }else{
            const page = pages[params.page];
            if(typeof page !== "object")  
                return <NotFound/>; 
            switch(page.style){
                case 'gallery':
                    return <Gallery page={page} {...this.props}/>
                case 'contact':
                    return <Contact page={page} changeState={this.props.changeState.bind(this)} state={this.props.state} {...this.props}/>
                case 'catalog':
                    if(typeof page.items ==="object"){
                        const props = {...this.props, settings:settings, page:page, params:params }
                        return <Catalog {...props} /> 
                    }
                    return <NotFound/>;
                default:
                    return <Page page={page} settings={settings} {...this.props}/>
            }
        }   
    }
}
export default Content;


// WEBPACK FOOTER //
// ./src/components/Content.js